import type { BotPromptSections } from '@/api/types';

export function normalizePromptSections(s: BotPromptSections): BotPromptSections {
  const out: BotPromptSections = {};
  const rules = (s.rules ?? []).map((r) => r.trim()).filter((r) => r.length > 0);
  const forbidden = (s.forbidden ?? []).map((r) => r.trim()).filter((r) => r.length > 0);
  const examples = (s.examples ?? [])
    .map((e) => ({ question: e.question.trim(), answer: e.answer.trim() }))
    .filter((e) => e.question.length > 0 && e.answer.length > 0);
  if (s.role?.trim()) out.role = s.role.trim();
  if (s.context?.trim()) out.context = s.context.trim();
  if (s.tone?.trim()) out.tone = s.tone.trim();
  if (rules.length > 0) out.rules = rules;
  if (forbidden.length > 0) out.forbidden = forbidden;
  if (s.tools?.trim()) out.tools = s.tools.trim();
  if (s.escalation?.trim()) out.escalation = s.escalation.trim();
  if (s.outputFormat?.trim()) out.outputFormat = s.outputFormat.trim();
  if (examples.length > 0) out.examples = examples;
  if (s.freeform?.trim()) out.freeform = s.freeform.trim();
  return out;
}
